export default __webpack_public_path__ + "static/media/alex2.06c120ff.jpg";